export default __webpack_public_path__ + "locales/uk-UA/About.json?hash=46cab12b3d49ac6efa88e0761dcdda06";